<template>
    <section>
        <!--顶部查询条件-->
        <Form :model="tqtExpert" inline>
            <FormItem>
                <Input v-model="tqtExpert.post" placeholder="职务" clearable></Input>
            </FormItem>
            <FormItem>
                <Input v-model="tqtExpert.unit" placeholder="单位" clearable></Input>
            </FormItem>
            <FormItem>
                <Input v-model="tqtExpert.name" placeholder="姓名" clearable></Input>
            </FormItem>
            <!--查询按钮-->
            <FormItem>
                <Button icon="ios-search" shape="circle" @click="search">查询</Button>
            </FormItem>

            <!--新建按钮-->
            <FormItem>
                <Button type="primary" icon="md-add" shape="circle" @click="create">新增</Button>
<!--                <Button type="primary" icon="ios-folder-open" shape="circle" style="margin-left: 20px" @click="create">-->
<!--                    导入-->
<!--                </Button>-->
                <Button
                        type="primary"
                        shape="circle"
                        style="margin-left: 20px"
                        @click="downTemplate"
                >下载导入模板
                </Button>
                <div style="display:inline-block">
                    <Upload :action="action" :headers="headers" :on-success="onSuccess" :on-format-error="handleFormatError" :format ="['xlsx','xls']" :on-error="onError">
                        <Button type="primary" icon="ios-folder-open" shape="circle" style="margin-left: 20px">导入</Button>
                    </Upload>
                </div>
                <Button type="primary" icon="md-download" shape="circle" style="margin-left: 20px"
                        @click="exportExpertList">导出
                </Button>
            </FormItem>

        </Form>

        <Table border :columns="columns" :pageOffset="pageOffset" :data="tableData" :loading="loading"></Table>

        <div class="page-area">
            <Page :total="pageTotal" :page-size="pageLength" @on-change="handlePageChange" show-total show-elevator/>
        </div>
    </section>
</template>
<script>
    import util from '@/libs/util.js'

    export default {
        name: 'tqtExpertList',

        data () {
            return {
                loading: false,
                //分页参数
                pageLength: 10, // 每页条数
                pageTotal: 0,//总数
                pageOffset: 1, //页码
                //查询参数
                tqtExpert: {
                    post: '',
                    unit: '',
                    name: '',
                    orginName:''
                },
                action: util.baseUrl + 'api/importExport',
                headers: { 'Authorization': localStorage.token },
                columns: [
                    {
                        key: 'order',
                        title: '序号',
                        align: 'center',
                        width:70
                    },
                    {
                        key: 'post',
                        title: '职务',
                        align: 'center',
                    },
                    // {
                    //     key: 'spec',
                    //     title: '专家简介',
                    //     align: 'center',
                    //     width: 135
                    // },
                    {
                        key: 'serviceContent',
                        title: '服务内容',
                        align: 'center',
                        width: 180
                    },
                    {
                        key: 'mobile',
                        title: '固定电话',
                        align: 'center',
                        width: 135
                    },
                    {
                        key: 'pic',
                        title: '照片',
                        align: 'center',
                        width: 140,
                        render: (h, params) => {
                            return h('div', [
                                h(
                                        'Img',
                                        {
                                            style:{"margin-top":"5px"},
                                            attrs: {
                                                src: params.row.imagePath.pic.url || '',
                                                width: '100%'
                                            },
                                        },
                                ),
                            ])
                        }
                    },
                    {
                        key: 'phone',
                        title: '手机号',
                        align: 'center',
                        width: 125
                    },
                    {
                        key: 'unit',
                        title: '单位',
                        align: 'center',
                    },
                    {
                        key: 'name',
                        title: '姓名',
                        align: 'center',
                    },

                    {
                        title: '操作',
                        align: 'center',
                        width: 140,
                        key: 'id',
                        render: (h, params) => {
                            return h('div', [
                                h(
                                        'Button',
                                        {
                                            props: {
                                                type: 'warning',
                                                size: 'small'
                                            },
                                            on: {
                                                click: () => {
                                                    this.edit(params.row.id)
                                                }
                                            }
                                        },
                                        '编辑'
                                ),
                                h('Button', {
                                    props: {
                                        type: 'error',
                                        size: 'small'
                                    },
                                    style: {
                                        marginLeft: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.delete(params.row.id)
                                        }
                                    }
                                }, '删除')
                            ])
                        }
                    }
                ],
                tableData: []
            }
        },
        mounted () {
            this.listTable()
        },
        methods: {
            formatTime (UTCDateString) {
                if (!UTCDateString) {
                    return '-'
                }

                function formatFunc (str) {    //格式化显示
                    return str > 9 ? str : '0' + str
                }

                var date2 = new Date(UTCDateString)     //这步是关键
                var year = date2.getFullYear()
                var mon = formatFunc(date2.getMonth() + 1)
                var day = formatFunc(date2.getDate())
                var hour = date2.getHours()
                var min = formatFunc(date2.getMinutes())
                var second = date2.getSeconds()
                var dateStr = year + '-' + mon + '-' + day
                return dateStr
            },
            //渲染表格数据
            listTable () {
                let _this = this
                _this.loading = true
                util.http.get('/api/tqtExpertsByCriteria', {
                    params: {
                        page: _this.pageOffset,
                        size: _this.pageLength,
                        post: _this.tqtExpert.post,
                        orginName: _this.tqtExpert.unit,
                        unit: _this.tqtExpert.unit,
                        name: _this.tqtExpert.name,
                        // ..._this.tqtExpert,
                    }
                }).then(function (response) {
                    _this.tableData = []
                    let data = response.data
                    _this.pageTotal = data.recordsTotal
                    let list = data.data
                    for (let i = 0; i < list.length; i++) {
                        let map = {
                            order: i + 1,
                            id: list[i].id,
                            userId: list[i].userId,
                            post: list[i].post,
                            orginName: list[i].orginName,
                            spec: list[i].spec,
                            type: list[i].type,
                            serviceContent: list[i].serviceContent,
                            mobile: list[i].mobile,
                            imagePath: list[i].imagePath,
                            phone: list[i].phone,
                            unit: list[i].unit,
                            name: list[i].name,
                        }
                        _this.tableData.push(map)
                    }
                    _this.loading = false
                }).catch(function (error) {
                    console.log(error)
                    _this.loading = false
                })
            },
            downTemplate(){
                let url = this.publicPath + '/template/专家数据导入模版.xlsx';
                const link = document.createElement('a');
                link.style.display = 'none';
                link.href = url;
                link.download = '专家数据导入模版.xlsx';
                document.body.appendChild(link);
                link.click();
            },
            //导出
            exportExpertList () {

                window.location.href = `${util.baseUrl}api/exportExpertList?post=${this.tqtExpert.post}&orginName=${this.tqtExpert.orginName}&name=${this.tqtExpert.name}`

                /* this.$http.get('/api/exportExpertList', {...this.tqtExpert}).then(res => {



                     let blob = new Blob([res]);
                     // 获取heads中的filename文件名
                     let downloadElement = document.createElement('a');
                     // 创建下载的链接
                     let href = window.URL.createObjectURL(blob);
                     downloadElement.href = href;
                     // 下载后文件名
                     downloadElement.download = '专家列表.xls';
                     document.body.appendChild(downloadElement);
                     // 点击下载
                     downloadElement.click();
                     // 下载完成移除元素
                     document.body.removeChild(downloadElement);
                     // 释放掉blob对象

                 })*/
            },

            //新建
            create () {
                this.$router.push({
                    name: 'tqt_expert_item',
                })
            },
            //编辑
            edit (id) {
                this.$router.push({
                    name: 'tqt_expert_item',
                    query: {
                        id: id
                    }
                })
            },
            //删除
            delete (id) {
                let _this = this
                this.$Modal.confirm({
                    title: '确定删除？',
                    onOk () {
                        util.http.delete('/api/tqtExperts/' + id).then(response => {
                            if (response.status === 200) {
                                _this.$Notice.success({
                                    title: '删除成功'
                                })
                                _this.listTable()
                            } else {
                                _this.$Notice.error({
                                    title: '删除失败'
                                })
                            }
                        })
                    }
                })
            },
            //查询
            search () {
                this.pageOffset = 1
                this.listTable()
            },
            handlePageChange (current) {
                this.pageOffset = current
                this.listTable()
            },
            onSuccess(response, file, fileList){
                if (response.status == 200) {
                    this.listTable()
                    this.$confirm(`${response.message}`, '提示', {
                        cancelButtonText: '取消',
                        confirmButtonText: '查看导入结果',
                    }).then(() => {
                        window.location.href = response.path
                    })
                }
            },
            handleFormatError(file){
                this.$Notice.warning({
                    title: '文件格式不正确',
                    desc: '文件 ' + file.name + ' 格式不正确，请上传.xls,.xlsx文件。'
                })
            },
            onError (response, file, fileList) {
            }
        }
    }
</script>
<style scoped>
    .query-model {
        width: 170px;
    }

    .page-area {
        display: flex;
        justify-content: flex-end;
        padding-top: 35px;
        padding-right: 50px;
    }

</style>

